export default __webpack_public_path__ + "static/media/rectangles-no-3.0eed2b58.ogg";